import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { CssBaseline, GlobalStyles } from '@mui/material';
import { TrackerProvider } from '@dpdgroupuk/react-event-tracker';
import { ThemeProvider } from '@mui/material/styles';
import { PersistGate } from 'redux-persist/integration/react';

import React from 'react';
import axe from 'react-axe';
import App from './App';
import theme from './theme';
import './index.scss';
import { persistor, store } from './redux/store';
import tracker from './helpers/analytics';
import { ErrorBoundary } from './features/ErrorBoundary';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
if (import.meta.env.NODE_ENV !== 'production') {
  axe(React, root, 1000);
}
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <TrackerProvider tracker={tracker}>
        <ThemeProvider theme={theme}>
          {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
          <CssBaseline />
          <GlobalStyles
            styles={{
              'input:-webkit-autofill': {
                boxShadow: '0 0 0 1000px white inset !important',
                WebkitTextFillColor: '#000 !important',
                transition: 'background-color 5000s ease-in-out 0s',
              },
            }}
          />
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </ThemeProvider>
      </TrackerProvider>
    </PersistGate>
  </Provider>
);
